import React, { useCallback, useState } from 'react';

import { defineMessages, useIntl } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports
import { Create } from '@atlaskit/atlassian-navigation';
import { ModalTransition } from '@atlaskit/modal-dialog';

import LazyCreateTeamDialog from '../../../../../../common/ui/CreateTeamDialog';
import { useStandaloneFlagActions } from '../../../../../../controllers/flags';
import { useOrgIdState } from '../../../../../../controllers/org-id';
import { useSiteStandaloneApp } from '../../../../../../controllers/site-standalone-app';

export const messages: {
	createTeamButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createTeamButtonLabel: {
		id: 'ptc-directory-ui.top-nav.create-team-button.label',
		defaultMessage: 'Create team',
		description: 'Label for the create team button in the top nav',
	},
});

export const CreateTeamButton = (): React.JSX.Element => {
	const [, { addFlag }] = useStandaloneFlagActions();
	const intl = useIntl();
	const [{ cloudId }] = useSiteStandaloneApp();
	const [{ orgId }] = useOrgIdState();
	const [isCreateTeamDialogOpen, setIsCreateTeamDialogOpen] = useState(false);

	const onClick = useCallback(() => {
		setIsCreateTeamDialogOpen(true);
	}, []);

	return (
		<>
			<Create text={intl.formatMessage(messages.createTeamButtonLabel)} onClick={onClick} />
			{isCreateTeamDialogOpen && (
				<ModalTransition>
					<LazyCreateTeamDialog
						orgId={orgId}
						cloudId={cloudId}
						addFlag={addFlag}
						onClose={() => setIsCreateTeamDialogOpen(false)}
					/>
				</ModalTransition>
			)}
		</>
	);
};
